import {useMemo} from "react";
import { BoundSearchQuery } from "../../types/common/BoundSearchQuery";

interface UseBoundQueryDownloadUrl {
  endpoint: string;
  query: BoundSearchQuery;
}

//the query object could include paging params. These should not be sent to the CSV downloads.
const OMITTED_KEYS = ['page', 'size'];

const OMITTED_VALUES = ['null', 'undefined', ''];

const useBoundQueryDownloadUrl = ({
  endpoint,
  query
}: UseBoundQueryDownloadUrl) => {

  const downloadUrl = useMemo(() => {
    //the query can consist of non-string values, such as integers and booleans. URLSearchParams assumes
    //all values are strings, and typescript, not being a real language, whines about converting it,
    //even though javascript itself can handle it just fine. So we have to cast values manually to shut typescript up.
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (!OMITTED_KEYS.includes(key)) {
        const stringValue = String(value).trim();
        if (!OMITTED_VALUES.includes(stringValue)) {
          searchParams.append(key, stringValue);
        }
      }
    }

    const searchString = searchParams.toString();
    return searchString ? `${endpoint}?${searchString}` : endpoint;
  }, [endpoint, query]);

  return downloadUrl;
}

export { useBoundQueryDownloadUrl };
